// extracted by mini-css-extract-plugin
export default {"header":"CreateTenant_header__tGEBb","row-field":"CreateTenant_row-field__oUv-A","rowField":"CreateTenant_row-field__oUv-A","error":"CreateTenant_error__4ZZHM"};